module.exports = __webpack_public_path__ + "img/coupon-2-fill.55ed403c.svg";